import { useNavigate } from "react-router-dom";
import FirstJoinSetup from "./components/FirstJoinSetup";

/**
 * 「首次加入資料」頁（QR 一鍵下單，結算的前一頁）：與首頁「首次完成設定」共用同一個 FirstJoinSetup
 * （鋼瓶數量/用途 → 鐵牌拍照+讀碼比對 → 配套配件 → 合約簽署 → walk-in 送後端）。
 * onboarding 流程已做過身分比對 → skipIdentity 不再問「是我/不是我」，直接從家中資料開始。
 * 舊版此頁是 demo（complete 不打後端、鐵牌只有相簿選擇），2026-07-15 汰換。
 */
const KioskJoin = () => {
  const navigate = useNavigate();
  return <FirstJoinSetup open skipIdentity disablePlateMatch onDone={() => navigate("/kiosk/confirm")} onClose={() => navigate("/kiosk/cart")} />;
};

export default KioskJoin;
